import {usePrimeVue} from '@primevue/core/config';
import {useTranslation} from '#imports';

export function useSetPrimevueLocales(): void {
    const {t} = useTranslation();
    const primevue = usePrimeVue();

    primevue.config = {
        ...primevue.config,
        locale: {
            ...primevue.config.locale!,
            dayNames: t('generic.calendar.weekdays').split(','),
            dayNamesShort: t('generic.calendar.weekdays.short').split(','),
            dayNamesMin: t('generic.calendar.weekdays.one.letter').split(','),
            monthNames: t('generic.calendar.months').split(','),
            monthNamesShort: t('generic.calendar.months.short').split(','),
            nextMonth: t('generic.datepicker.next.month'),
            prevMonth: t('generic.datepicker.previous.month'),
            chooseYear: t('generic.datepicker.choose.year'),
            chooseMonth: t('generic.datepicker.choose.month'),
            today: t('generic.date.today'),
            clear: t('generic.datepicker.clear'),
        },
    };
}

export {useSetPrimevueLocales as setPrimevueLocales};
